import { Button as B } from '@rmwc/button';
import styled from 'styled-components';
import '@material/button/dist/mdc.button.css';

export const Button = styled(B)`
  text-transform: none;
`;

export default Button;
